export default () => {
  const a = new Uint32Array(6)
  return Array.from(window.crypto.getRandomValues(a))
    .map(i => i.toString(16))
    .join('-')
}
